export class TeamStat {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "TeamStat";
    this.scene = "Team Stat";
    this.normal_scene = "Team Stat";
    this.game_management_scene = "Game Management";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;

    if (options.category === "Game Management") {
      this.buildGameManagement({ options });
    } else {
      this.buildTeamStat({ options });
    }
  }
  buildTeamStat({ options }) {
    this.scene = this.normal_scene;
    this.data = [];
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Category",
      value: {
        text: options.category || "",
      },
    });

    this.data.push({
      name: "Secondary Category",
      value: {
        text: options.secondary_category || "",
      },
    });
    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Value",
      value: {
        text: options.stat?.home || "0",
      },
    });
    this.data.push({
      name: "Away Team Value",
      value: {
        text: options.stat?.away || "0",
      },
    });

    this.data.push({
      name: "Home Team Secondary Value",
      value: {
        text: options.secondary_stat?.home || "0",
      },
    });
    this.data.push({
      name: "Away Team Secondary Value",
      value: {
        text: options.secondary_stat?.away || "0",
      },
    });

    this.data.push({
      name: "Home Team Name",
      value: {
        text: options.game?.home_team?.name || "",
      },
    });

    this.data.push({
      name: "Home Team Code",
      value: {
        text: options.game?.home_team?.code || "",
      },
    });

    this.data.push({
      name: "Home Team Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.alt_badge || "",
      },
    });

    this.data.push({
      name: "Away Team Name",
      value: {
        text: options.game?.away_team?.name || "",
      },
    });

    this.data.push({
      name: "Away Team Code",
      value: {
        text: options.game?.away_team?.code || "",
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  buildGameManagement({ options }) {
    this.scene = this.game_management_scene;
    this.data = [];
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });
    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
          ] || "",
      },
    });

    this.data.push({
      name: "Home Team Possession Value",
      value: {
        text:
          options.game?.opta_team_stats?.home?.find(
            (stat) => stat.type === "possessionPercentage"
          )?.value || "0",
      },
    });
    this.data.push({
      name: "Home Team Pass Value",
      value: {
        text:
          options.game?.opta_team_stats?.home?.find(
            (stat) => stat.type === "accuratePass"
          )?.value || "0",
      },
    });

    this.data.push({
      name: "Away Team Possession Value",
      value: {
        text:
          options.game?.opta_team_stats?.away?.find(
            (stat) => stat.type === "possessionPercentage"
          )?.value || "0",
      },
    });
    this.data.push({
      name: "Away Team Pass Value",
      value: {
        text:
          options.game?.opta_team_stats?.away?.find(
            (stat) => stat.type === "accuratePass"
          )?.value || "0",
      },
    });

    this.data.push({
      name: "Home Team Name",
      value: {
        text: options.game?.home_team?.name || "",
      },
    });

    this.data.push({
      name: "Home Team Code",
      value: {
        text: options.game?.home_team?.code || "",
      },
    });

    this.data.push({
      name: "Home Team Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.alt_badge || "",
      },
    });

    this.data.push({
      name: "Away Team Name",
      value: {
        text: options.game?.away_team?.name || "",
      },
    });

    this.data.push({
      name: "Away Team Code",
      value: {
        text: options.game?.away_team?.code || "",
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
